import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { SuggestAChangeService } from '../../airport/service/suggest-a-change.service';
import { State } from '../state-view/state.model';
import { UserService } from '../user/user.service';
var SuggestAChangeComponent = /** @class */ (function () {
    function SuggestAChangeComponent(_matDialogRef, data, _suggestAChangeService, _userService) {
        this._matDialogRef = _matDialogRef;
        this._suggestAChangeService = _suggestAChangeService;
        this._userService = _userService;
        this.isLoading = true;
        this.isAirport = false;
        this.state = State.Empty;
        this.isAirport = data.airportID != null;
        this.ident = data.airportID || data.businessID;
        this.airportAbbrev = data.airportAbbrev;
    }
    SuggestAChangeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl('', [Validators.maxLength(50)]),
            email: new FormControl('', [Validators.email]),
            details: new FormControl('', [Validators.required]),
        });
        this.isLoading = false;
        // Update state based on latest available userInfo, and subscribe to any future
        // changes to userInfo.
        this._userInfo = this._userService.userInfo.getValue();
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            // Set state to loaded
            _this.state = State.Content;
        });
    };
    SuggestAChangeComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, changeRequest, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        changeRequest = {
                            name: this.formGroup.value.name,
                            email: this.formGroup.value.email,
                            details: this.formGroup.value.details,
                            recId: this._userInfo ? +this._userInfo.masterCustomerId : null
                        };
                        if (!this.isAirport) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._suggestAChangeService.postChangeRequestAirport(this.ident, this.airportAbbrev, changeRequest)];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._suggestAChangeService.postChangeRequestBusiness(this.ident, changeRequest)];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1.error });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    SuggestAChangeComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    SuggestAChangeComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    return SuggestAChangeComponent;
}());
export { SuggestAChangeComponent };
